'use strict';

var React = require('react');

const StickyManagerContext = /*#__PURE__*/React.createContext(undefined);

exports.StickyManagerContext = StickyManagerContext;
